import React, { useEffect } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
    root: {
        width: 500,
        '& > * + *': {
            marginTop: theme.spacing(3),
        },
    },
}));

export default function MultiSelect({ placeholder = "", disabled = false, options = [], valueKey, displayKey, filterKeys, value = [], onChange = () => { }, renderOption, inputProps = {} }) {
    if (!displayKey) {
        displayKey = valueKey;
    }
    if (!filterKeys) {
        filterKeys = [displayKey];
    }
    const classes = useStyles();

    const autoCompleteOptions = {

    };

    if (renderOption) {
        autoCompleteOptions.renderOption = renderOption;
    }

    const handleInputChange = (event) => {
      if (!event.target.value.trim()) {
        return;
      }
      onChange(event, [...value, event.target.value.trim()]);
      event.target.value = "";
      event.preventDefault();
      event.stopPropagation();
    };

    return (
        <div className={classes.root}>
            <Autocomplete
                multiple
                id="tags-filled"
                options={options}
                freeSolo
                onChange={(e, values) => {
                    values = values.map(val => val?.[valueKey] || val);
                    values = values.filter((value,index) => values.indexOf(value) == index);
                    onChange(e, values);
                }}
                value={value}
                disabled={disabled}
                disableCloseOnSelect={true}
                filterOptions={(options, state) => {
                    return options.filter((option) => {
                        for (let i = 0; i < filterKeys.length; i++) {
                            if (option[filterKeys[i]].toLowerCase().includes(state.inputValue.toLowerCase())) {
                                return true;
                            }
                        }
                        return false;
                    });
                }}
                renderTags={(value, getTagProps) =>
                    value.map((val, index) => (
                        <Tag variant="outlined"
                            label={options.find((option) => option[valueKey] === val)
                                ? options.find((option) => option[valueKey] === val)[displayKey]
                                : val}
                            {...getTagProps({ index })} />
                    ))
                }
                getOptionLabel={(option) => option[displayKey]}
                renderInput={(params) => {
                    return <TextField
                        variant="outlined"
                        color="primary"
                        placeholder={placeholder}
                        onKeyPress={(event) => {
                            if (
                              event.key !== "," &&
                              event.key !== "Enter" &&
                              event.key !== " " && 
                              event.key !== "Tab"
                            ) {
                              return;
                            }
                            handleInputChange(event);
                        }}
                        onBlur={handleInputChange}
                        {...params}
                    />
                }}
                {...autoCompleteOptions}
            />
        </div>
    );
}

const Tag = ({ label, onDelete, ...props }) => (
    <div {...props} className="autocomplete_tag">
        <span>{label}</span>
        <CloseIcon onClick={onDelete} />
    </div>
)